module.exports = __webpack_public_path__ + "img/aerosoles.e16a2d0c.webp";